document.addEventListener('DOMContentLoaded', () => {
  let revertTimeout;

  const checkAndAddListeners = () => {
    if (document.querySelectorAll('[js-swatch-input="link"]').length) {
      document.querySelectorAll('[js-swatch-input="link"]').forEach((swatch) => {
        swatch.addEventListener('mouseover', (event) => {
          clearTimeout(revertTimeout);

          const cardWrapper = event.currentTarget.closest('.card-wrapper');
          const imageToChange =
            cardWrapper.querySelector('[js-card-product="secondary-media"]') ||
            cardWrapper.querySelector('[js-card-product="featured-media"]');

          if (imageToChange) {
            if (!imageToChange.dataset.originalImageUrl) {
              imageToChange.dataset.originalImageUrl = imageToChange.src;
              imageToChange.dataset.originalSrcset = imageToChange.srcset;
            }
            imageToChange.src = event.currentTarget.getAttribute('data-variant-image');
            imageToChange.srcset = '';
          }
        });

        /**
         * Mouse out event listener.
         */
        swatch.addEventListener('mouseout', (event) => {
          const cardWrapper = event.currentTarget.closest('.card-wrapper');
          const imageToRestore =
            cardWrapper.querySelector('[js-card-product="secondary-media"]') ||
            cardWrapper.querySelector('[js-card-product="featured-media"]');

          if (imageToRestore) {
            revertTimeout = setTimeout(() => {
              imageToRestore.src = imageToRestore.dataset.originalImageUrl;
              imageToRestore.srcset = imageToRestore.dataset.originalSrcset;
            }, 200);
          }
        });
      });
      return true;
    }
    return false;
  };

  if (!checkAndAddListeners()) {
    new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && checkAndAddListeners()) {
          observer.disconnect();
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
});
